/*  MUI  */
import { Restore } from '@mui/icons-material';
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Typography
} from '@mui/material';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const LastUpdatedCard = ({
    buttonText,
    content,
    filteredResults,
    lastUpdated,
    route,
    title
}: {
    buttonText?: string;
    content: string | number | JSX.Element;
    filteredResults?: boolean;
    lastUpdated: string | JSX.Element;
    route?: string;
    title: string;
}) => {
    const { t } = useTranslation();
    return (
        <Card
            variant="outlined"
            data-testid="lastUpdatedCard"
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'space-between'
            }}
        >
            <CardHeader
                data-testid="lastUpdatedCardHeader"
                title={<Typography>{title}</Typography>}
            />
            <CardContent
                data-testid="lastUpdatedCardContent"
                sx={{ paddingY: '4px' }}
            >
                <Typography color="text.cardKPI" variant="h2">
                    {content}
                </Typography>
            </CardContent>
            <CardActions data-testid="lastUpdatedCardActions">
                <Box display="flex" flexDirection="column" width="100%">
                    <hr />
                    <Box mb="16px" pl="8px">
                        <Typography fontSize={FontSizes[0]}>
                            <Restore
                                style={{
                                    fontSize: FontSizes[2],
                                    marginRight: '4px'
                                }}
                            />
                            {lastUpdated}
                        </Typography>
                    </Box>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                    >
                        {buttonText && route && (
                            <Link
                                to={route}
                                data-testid="lastUpdatedCardLinkTo"
                            >
                                <Button
                                    data-testid="lastUpdatedCardButton"
                                    size="small"
                                    sx={{
                                        color: 'button.primary',
                                        paddingLeft: '8px'
                                    }}
                                >
                                    {buttonText}
                                </Button>
                            </Link>
                        )}
                        {filteredResults && (
                            <Typography color="text.primaryFaded">
                                <small>*{t('Common.filtered_results')}</small>
                            </Typography>
                        )}
                    </Box>
                </Box>
            </CardActions>
        </Card>
    );
};
